import { useNewTranslation } from 'hooks'
import ReminderAlert from 'particles/Alert/ReminderAlert'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectTemplateDetail } from 'state/campaignTemplates'
import { CampaignPaymentSummaryData } from 'services/api/campaigns'

interface BannerAlertProps {
    paymentSummary: CampaignPaymentSummaryData
}

const BannerAlert = ({ paymentSummary }: BannerAlertProps) => {
    const templateDetail = useSelector(selectTemplateDetail)
    const [t] = useNewTranslation()

    if (!paymentSummary) {
        return null
    }
    if (paymentSummary?.slot_number !== null && paymentSummary?.slot_number < 1) {
        return (
            <ReminderAlert
                form="error"
                title={t('campaign.template.step3.paymentConfirmation.payoutBreakdown.errorReminder.title')}
                subtext={t('campaign.template.step3.paymentConfirmation.payoutBreakdown.errorReminder.subtext')}
                width="100%"
            />
        )
    }

    if (paymentSummary?.left_over_budget < 0) {
        return (
            <ReminderAlert
                form="warning"
                title={t('campaign.campaignEditor.paymentBreakdown.negativeAdditionalBudget.title')}
                subtext={t('campaign.campaignEditor.paymentBreakdown.negativeAdditionalBudget.subText')}
                width="100%"
            />
        )
    }

    if (paymentSummary?.payable_amount < 0) {
        return (
            <ReminderAlert
                form="error"
                title={t(
                    'campaign.template.step3.paymentConfirmation.payoutBreakdownReminder.negativeCampaignPayment.title',
                )}
                subtext={t(
                    'campaign.template.step3.paymentConfirmation.payoutBreakdownReminder.negativeCampaignPayment.subrext',
                )}
                width="100%"
            />
        )
    }

    if (!templateDetail?.kpi_range) {
        return null
    }

    if (paymentSummary.slot_number !== null && paymentSummary?.slot_number < templateDetail.kpi_range.min) {
        return (
            <ReminderAlert
                form="warning"
                title={t(
                    'campaign.template.step3.paymentConfirmation.payoutBreakdown.warningReminder.belowMinimum.title',
                    { minimumParticipants: templateDetail.kpi_range.min },
                )}
                subtext={t(
                    'campaign.template.step3.paymentConfirmation.payoutBreakdown.warningReminder.belowMinimum.subtext',
                )}
                width="100%"
            />
        )
    }

    if (paymentSummary.slot_number !== null && paymentSummary?.slot_number > templateDetail.kpi_range.max) {
        return (
            <ReminderAlert
                form="warning"
                title={t(
                    'campaign.template.step3.paymentConfirmation.payoutBreakdown.warningReminder.overMaximum.title',
                )}
                subtext={t(
                    'campaign.template.step3.paymentConfirmation.payoutBreakdown.warningReminder.overMaximum.subtext',
                )}
                width="100%"
            />
        )
    }

    return null
}

export default BannerAlert
